export const DockActivity = {
  ALL: 'All doors',
  OPEN: 'Open',
  PENDING: 'Pending',
  WORKING: 'Working',
  LIVE: 'Live',
  DROP: 'Drop',
  OUT_OF_SERVICE: 'OutOfService',
} as const;

export type DockActivity = (typeof DockActivity)[keyof typeof DockActivity];
